/*
 * @Author: songpan
 * @Date: 2022-03-07 16:43:37
 * @LastEditTime: 2022-03-20 23:21:11
 * @LastEditors: songpan
 * @Description: 路由配置页面
 */

import HomeView from '@/views/home/HomeView.vue';
import RecomMend from '@/views/recommend/RecomMend.vue';
import UserAgreement from '@/views/useragreement/UserAgreement.vue';
import { RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/recommend',
    name: 'recommend',
    meta: {
      keepAlive: true,
      title: '邀好友 赚佣金',
    },
    component: RecomMend,
  },
  {
    path: '/useragreement',
    name: 'useragreement',
    component: UserAgreement,
  },
];

export { routes };
